import React, {useEffect, useRef, useState} from 'react';

//import * as LogFunctions from './../Helpers/LogFunctions';
import {
    ActivityIndicator, CCText,
    Modal,
    ScrollView,
    View
} from '../../../custom-packages/react-native-components-in-react/react-native-components-in-react';


import {useSelector} from 'react-redux';
import {BorderlessButton, DarkButton, ThemeButton} from '../../../custom-packages/react-button-package/ButtonPackage';
import AppConfig from '../../../AppConfig';
import ChocoForm from '../../../custom-packages/react-chocoforms/legacy/ChocoForm';
import FoodPricing from "./FoodPricing";

const TNewFoodModal = {
    // English
    "enUS": {
        'NEW_FOOD': 'New Food',
        'NAME': 'Name',
        'DESCRIPTION': 'Description (Optional)',
        'ADD_PRICE': 'Add Price',
        'PRICES': 'Prices',
        'PRICES_DESC': 'You will be able to add more prices by editing your product later.',
        'SAVE': 'Save',
        'CANCEL': 'Cancel',
        'PRICE_INSTRUCTIONS': 'For multiple prices you must give each price a name (small, medium, big, etc.)',
    },
    // Spanish
    "esMX": {
        'NEW_FOOD': 'Nuevo Alimento',
        'NAME': 'Nombre',
        'DESCRIPTION': 'Descripción (Opcional)',
        'ADD_PRICE': 'Agregar Precio',
        'PRICES': 'Precios',
        'PRICES_DESC': 'Podrás agregar más precios editando tu producto tras crearlo.',
        'SAVE': 'Guardar',
        'CANCEL': 'Cancelar',
        'PRICE_INSTRUCTIONS': 'Para múltiples precios debes de darle un nombre a cada precio (pequeño, mediano, grande, etc.)',
    }
}

const NewFoodModal = (props) => {
    const pricingDivRef = useRef(null);
    const auth = useSelector(state => state.Auth);

    const [saving, setSaving] = useState(false);
    const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);

    const [nextPriceId, setNextPriceId] = useState(1);

    const [form, setForm] = useState({
        controls: {
            foo_name: {
                elementType: 'input',
                label: TNewFoodModal[AppConfig.lang].NAME,
                elementConfig: {
                    placeholder: TNewFoodModal[AppConfig.lang].NAME,
                    autoCapitalize: 'words'
                },
                value: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false,
            },
            foo_description: {
                elementType: 'input',
                label: TNewFoodModal[AppConfig.lang].DESCRIPTION,
                elementConfig: {
                    placeholder: TNewFoodModal[AppConfig.lang].DESCRIPTION,
                    autoCapitalize: 'words'
                },
                value: '',
                validation: {
                    required: false
                },
                valid: false,
                touched: false,
            },
        },
    });

    const [pricingForms, setPricingForms] = useState([
        {
            id: 0,
            defaultTitle: true
        }
    ])

    useEffect(async () => {
        const controls = {...form.controls};

        controls.foo_name.value = props.initialName;

        form.controls = controls;

        if(props.initialName)
            form.isValidForm = true;

        setForm(form);
    }, [props.initialName]);

    return (
        <Modal
            visible={props.visible}
            onRequestClose={props.onRequestClose}
            hideHeader={true}
            footer={
                <View style={{flexDirection: 'row', justifyContent: 'flex-end'}}>
                    {saving ?
                        <ActivityIndicator style={{marginRight: 7}}/>
                        :
                        <View style={{flexDirection: 'row', justifyContent: 'flex-end'}}>
                            <BorderlessButton
                                text={TNewFoodModal[AppConfig.lang].CANCEL}
                                onPress={() => {
                                    // Set it control value to ''
                                    const controls = {...form.controls};

                                    for (let key in controls) {
                                        controls[key].value = '';
                                    }

                                    form.controls = controls;

                                    setForm(form);

                                    props.onRequestClose();
                                }}
                            />
                            <View style={{ width: 7 }}></View>
                            <ThemeButton
                                disabled={saveButtonDisabled}
                                text={TNewFoodModal[AppConfig.lang].SAVE}
                                onPress={async () => {
                                    const controls = {...form.controls};

                                    if (form.isValidForm) {
                                        setSaving(true);
                                        setSaveButtonDisabled(true);

                                        let formData = {};

                                        for (let key in controls) {
                                            formData[key] = controls[key].value;
                                        }

                                        formData['prices'] = [];

                                        for(let i = 0; i < pricingForms.length; i++){
                                            formData['prices'].push({
                                                fpr_title: pricingForms[i].controls.fpr_title ? pricingForms[i].controls.fpr_title.value : null,
                                                fpr_price: pricingForms[i].controls.fpr_price.value,
                                                fpr_currency: pricingForms[i].controls.fpr_currency.value,
                                            })
                                        }

                                        const response = await fetch(AppConfig.URL + '/Food/Create/', {
                                            method: 'POST',
                                            headers: {
                                                'Accept': 'application/json',
                                                'Content-Type': 'application/json',
                                                'Authorization': auth.token
                                            },
                                            body: JSON.stringify(formData)
                                        });

                                        const data = await response.json();

                                        if (data.success) {
                                            const controls = {...form.controls};

                                            for (let key in controls) {
                                                controls[key].value = '';
                                            }

                                            form.controls = controls;

                                            setForm(form);
                                            setPricingForms([{
                                                id: 0,
                                                defaultTitle: true
                                            }])
                                            setNextPriceId(1);

                                            props.callback(data.food);
                                        }

                                        setSaving(false);
                                    } else {

                                    }
                                }}
                            />
                        </View>
                    }
                </View>}
        >
            <ScrollView style={{width: '100%'}}>
                <View>
                    <h1>
                        {TNewFoodModal[AppConfig.lang].NEW_FOOD}
                    </h1>
                    <ChocoForm
                        containerStyle={{padding: 0}}
                        lang={AppConfig.lang}
                        form={form}
                        onFormChange={(updatedForm) => {
                            let pricingFormsValid = true;

                            for(let i = 0; i < pricingForms.length; i++){
                                if(!pricingForms[i].isValidForm) {
                                    pricingFormsValid = false;
                                    break;
                                }
                            }

                            setForm(updatedForm);
                            setSaveButtonDisabled(!(updatedForm.isValidForm && pricingFormsValid))
                        }}
                    />
                    <View
                        style={{
                            marginTop: 40,
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'flex-end'
                        }}
                    >
                        <h4
                            style={{
                                margin: 0
                            }}
                        >
                            {TNewFoodModal[AppConfig.lang].PRICES}
                        </h4>
                    </View>
                    <View>
                        <CCText
                            style={{
                                marginTop: 5,
                                marginBottom: 15,
                                color: '#444444',
                                fontSize: '1.15rem',
                                textAlign: 'justify'
                            }}
                        >
                            {TNewFoodModal[AppConfig.lang].PRICE_INSTRUCTIONS}
                        </CCText>
                    </View>
                    {
                        pricingForms.map(item => <FoodPricing
                            key={item.id}
                            id={item.id}
                            defaultTitle={item.defaultTitle}
                            style={{ marginBottom: 25 }}
                            editable={true}
                            hideName={pricingForms.length === 1}
                            deletable={pricingForms.length > 1}
                            deletableWhileEditing={pricingForms.length > 1}
                            onDelete={(form) => {
                                const forms = [...pricingForms]
                                const index = pricingForms.findIndex(i => i.id == item.id)

                                if(index > -1){
                                    forms.splice(index, 1);

                                    setPricingForms(forms)
                                }
                            }}
                            returnForm={(returnedForm) => {
                                const forms = [...pricingForms]
                                const index = forms.findIndex(i => i.id == item.id)

                                if(index > -1){
                                    forms[index] = returnedForm;

                                    setPricingForms(forms)
                                    setSaveButtonDisabled(!(form.isValidForm && returnedForm.isValidForm))
                                }
                            }}
                        />)
                    }
                    <DarkButton
                        text={TNewFoodModal[AppConfig.lang].ADD_PRICE}
                        onPress={() => {
                            const forms = [...pricingForms];

                            forms.push({
                                id: nextPriceId
                            })
                            setPricingForms(forms)
                            setSaveButtonDisabled(true)
                            setNextPriceId(nextPriceId + 1)
                        }}
                        style={{textAlign: 'center'}}
                    />
                    <View style={{ height: 100 }}></View>
                </View>
            </ScrollView>
        </Modal>
    );
}

export default NewFoodModal;